import xhrService from "../api";

export const dashboard = {
  fetch: (path) => {
    return xhrService.get(`/api${path}`).then(res => res.data);
  },
};

export const customDashboard = {
  fetch: (path) => {
    return xhrService.get(`/api${path}`).then(res => res.data);
  },
  /**
   * @param config  extra axios config, merged over the params. SW2-2325 uses it to pass
   *   a `cancelToken` — axios is pinned at 0.18.1 here, which predates `AbortController`
   *   support (that landed in 0.22), so `CancelToken` is the only way to abandon a
   *   request in flight.
   */
  fetchWithParams: (path, paramsObject, config = {}) => {
    return xhrService.get(`/api${path}`, {
      params: paramsObject,
      ...config
    })
    .then(res => res.data);
  },
  post: (path,data) => {
    return xhrService.post(`/api${path}`,data).then(res => res.data);
  },
};

export default dashboard;
